<ng-container *ngIf="codeAvailable$ | async">
  <jml-lib-code-editor
    *ngIf="fieldReadable; else noPermissions"
    [readonly]="!fieldWritable || entityReadOnly"
    [syntax]="syntax"
    [code]="code"
    saveButtonLabel="Übernehmen"
    [saveIcon]="getIcon(internalState$ | async)"
    (editedCode)="updateEntity($event)"
    (setDirty)="isDirty = $event"
  >
  </jml-lib-code-editor>
</ng-container>

<ng-template #noPermissions>
  <p>
    Missing permissions to display field <b>{{ this.fieldName }}</b>
  </p>
</ng-template>
